import { havAccordion } from './components/Accordion'
import { havErrorAlert } from './components/Alerts'
import {
  havBigPrimaryButton,
  havGhostButton,
  havIconButton,
  havPrimaryButton,
  havTextButton,
} from './components/Buttons'
import { havMasterFieldInput } from './components/Inputs'
import { havModalShape } from './components/Modal'
import { havPagination } from './components/Pagination'
import { havComplexTable, havSimpleTable } from './components/Tables'
import { havTag } from './components/Tag'
import {
  havDefault01Text,
  havDefault02Text,
  havH1Text,
  havH2Text,
  havH3Text,
  havH4Text,
  havH5Text,
  havSubtitleText,
} from './components/Texts'
import type { HAVDesignTokensInterface } from './interfaces'
import { icon, palette, shape, spacing, typography } from './values'

let HAVDesignTokens: HAVDesignTokensInterface = {
  icon,
  palette,
  shape,
  spacing,
  typography,
}

HAVDesignTokens = {
  ...HAVDesignTokens,
  DSComponents: {
    accodion: {
      havAccordion: havAccordion(HAVDesignTokens),
    },
    alerts: {
      havErrorAlert: havErrorAlert(HAVDesignTokens),
    },
    buttons: {
      havBigPrimaryButton: havBigPrimaryButton(HAVDesignTokens),
      havGhostButton: havGhostButton(HAVDesignTokens),
      havIconButton: havIconButton(HAVDesignTokens),
      havPrimaryButton: havPrimaryButton(HAVDesignTokens),
      havTextButton: havTextButton(HAVDesignTokens),
    },
    inputs: {
      havMasterFieldInput: havMasterFieldInput(HAVDesignTokens),
    },
    pagination: {
      havPagination: havPagination(HAVDesignTokens),
    },
    shapes: {
      havModalShape: havModalShape(HAVDesignTokens),
    },
    tables: {
      havComplexTable: havComplexTable(HAVDesignTokens),
      havSimpleTable: havSimpleTable(HAVDesignTokens),
    },
    tag: {
      havTag: havTag(HAVDesignTokens),
    },
    texts: {
      havDefault01Text: havDefault01Text(HAVDesignTokens),
      havDefault02Text: havDefault02Text(HAVDesignTokens),
      havH1Text: havH1Text(HAVDesignTokens),
      havH2Text: havH2Text(HAVDesignTokens),
      havH3Text: havH3Text(HAVDesignTokens),
      havH4Text: havH4Text(HAVDesignTokens),
      havH5Text: havH5Text(HAVDesignTokens),
      havSubtitleText: havSubtitleText(HAVDesignTokens),
    },
  },
}

export default HAVDesignTokens
